export const PROMOTED_SHOWS_KNOWLEDGE_BASE_URL = 'https://knowledge.bambuser.com/en_US/socialcommercefeatures/in-player-show-promotion';
